module.exports = "<ul class=\"nav nav-{{type || 'pills'}}\" ng-class=\"{'nav-stacked': vertical, 'nav-justified': justified}\" ng-transclude> </ul>";